import { z } from "zod";

export enum AccountCreatedFromSource {
  Unknown = "unknown",
  WorkCanvas = "workcanvas",
  Monday = "monday",
}

export const accountSchema = z.object({
  id: z.string(),
  name: z.string(),
  slug: z.string(),
  logo: z.string().nullish(),
  createdFromSource: z.nativeEnum(AccountCreatedFromSource).optional(),
  createdAt: z.string().nullish(),
});

export function accountFromDBModel(obj: any): Account {
  return accountSchema.parse(obj);
}

export type Account = z.infer<typeof accountSchema>;

export type MinimalAccount = Pick<Account, "id">;

export type AccountDBSchema = {
  id: string;
  created_at: string;
  updated_at: string;
  created_reflect_room: boolean;
  created_from_source: AccountCreatedFromSource;
};
